module.exports = __webpack_public_path__ + "static/media/carbody-3.0ab1cfca.png";